import { Box, NumberInput, NumberInputField, Td, Tr } from "@chakra-ui/react";
import { GroupBase, Select as AutoComplete } from "chakra-react-select";
import { NewProduct } from "models/new_product_type";
import { OrderCategory } from "models/order_category";
import { OrderItemProduct } from "models/order_item_product";
import { OptionType } from "models/select_mode";
import formatNumber from "views/admin/order/hooks/formatNumber";

interface IOrderProductItem{
    categ: OrderCategory
    item: OrderItemProduct;
    produtos: NewProduct[];
}

const OrderProductItem = ({categ, item, produtos}:IOrderProductItem ) => {
    return (
        <Tr>
          <Td>
            <Box w={300}>
              <AutoComplete<OptionType, false, GroupBase<OptionType>>
                size="md"
              
                placeholder="Buscar..."
                isDisabled={false}
                name={"Produto"}
                options={produtos?.map((item) => {
                  return {
                    label: item?.nome,
                    value: item?.id,
                  };
                })}
                value={{
                  label: item?.NovoProduto?.nome,
                  value: item.NovoProduto.id,
                }}
              />
            </Box>
          </Td>
          <Td>{item?.NovoProduto?.sku}</Td>
          <Td> {item?.NovoProduto?.nome}</Td>
          <Td>
            <NumberInput
              precision={2}
              defaultValue={item?.quantidade}
              style={{
                width: 100,
              }}
              name={`quantidade--`}
              
            >
              <NumberInputField />
            </NumberInput>
          </Td>
          <Td>
            {isNaN(item?.NovoProduto?.precoVenda)
              ? formatNumber(0)
              : formatNumber(Number(item?.NovoProduto?.precoVenda))}
          </Td>
          <Td>{formatNumber(Number(item.valorTotal))}</Td>

        </Tr>
      );
}
export default OrderProductItem;